import React from 'react';

type Props = {
  className?: string;
};

const ProtectionIcon: React.FC<Props> = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask
      id="mask0_5505_211"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_5505_211)">
      <path
        d="M12 22C9.68333 21.4167 7.77083 20.0875 6.2625 18.0125C4.75417 15.9375 4 13.6333 4 11.1V5L12 2L20 5V11.1C20 13.6333 19.2458 15.9375 17.7375 18.0125C16.2292 20.0875 14.3167 21.4167 12 22ZM12 19.9C13.7333 19.35 15.1667 18.25 16.3 16.6C17.4333 14.95 18 13.1167 18 11.1V6.375L12 4.125L6 6.375V11.1C6 13.1167 6.56666 14.95 7.7 16.6C8.83333 18.25 10.2667 19.35 12 19.9Z"
        fill="black"
      />
      <path
        d="M16.6008 9.9001L10.9508 15.5501L7.42578 12.0251L8.85078 10.6001L10.9508 12.7001L15.1758 8.4751L16.6008 9.9001Z"
        fill="#298842"
      />
    </g>
  </svg>
);

export default ProtectionIcon;
